import { isReadyForAdminFinalApproval, readReadyForAdminFinalApproval } from '@/utils/review-final-approval'

function normalizeStatus(value) {
  return String(value || '').trim().toLowerCase()
}

function normalizeStatusKey(value) {
  const status = normalizeStatus(value)

  if (status === 'approved') return 'approved'
  if (status === 'rejected') return 'rejected'
  if (status === 'revision') return 'revision'
  if (status === 'pending' || status === 'submitted' || status === 'suggestion' || status === 'in-review') return 'in-review'
  if (status === 'final-review' || status === 'sent-to-admin') return 'sent-to-admin'
  if (status === 'draft') return 'draft'

  return status || 'draft'
}

export function getAgreementWorkflowStatusKey(item) {
  if (!item || typeof item !== 'object') return normalizeStatusKey(item)

  const workflow = item.workflow && typeof item.workflow === 'object' ? item.workflow : {}
  const workflowStatus = normalizeStatus(workflow.status || item.workflowStatus || item.status)
  const derivedStage = normalizeStatus(item.derivedStage)
  const explicitReadyForAdminFinalApproval = readReadyForAdminFinalApproval(item)
  const readyForAdminFinalApproval = isReadyForAdminFinalApproval(item)

  if (workflowStatus === 'approved' || derivedStage === 'approved') return 'approved'
  if (workflowStatus === 'rejected') return 'rejected'
  if (readyForAdminFinalApproval || (explicitReadyForAdminFinalApproval === null && derivedStage === 'final-review')) {
    return 'sent-to-admin'
  }
  if (workflowStatus === 'revision' || derivedStage === 'revision') return 'revision'
  if (workflowStatus === 'pending' || derivedStage === 'submitted' || derivedStage === 'suggestion') return 'in-review'
  if (workflowStatus === 'draft' || derivedStage === 'draft') return 'draft'
  if (Number(workflow.currentStep || item.currentStep || 1) >= 2) return 'in-review'

  return normalizeStatusKey(workflowStatus || derivedStage)
}

export function getAgreementWorkflowStatusLabel(item) {
  const statusKey = getAgreementWorkflowStatusKey(item)

  return {
    approved: 'Approved',
    'in-review': 'Review',
    'sent-to-admin': 'Sent to Admin',
    rejected: 'Rejected',
    draft: 'Draft',
    revision: 'Revision Required'
  }[statusKey] || 'Draft'
}

export function getAgreementWorkflowStatusTone(item) {
  const statusKey = getAgreementWorkflowStatusKey(item)

  return {
    approved: 'approved',
    'in-review': 'pending',
    'sent-to-admin': 'admin',
    rejected: 'rejected',
    draft: 'draft',
    revision: 'revision'
  }[statusKey] || 'draft'
}
